import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OfficeLocation = () => {
  const officeInfo = {
    name: 'AdvoCall Professional',
    parent: 'ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH',
    address: {
      street: 'Kurfürstendamm 14',
      city: '10719 Berlin',
      country: 'Deutschland'
    },
    contact: {
      phone: '09001000312',
      email: 'info@advocall.de',
      fax: '+49 69 348 740 919'
    },
    hours: [
      { day: 'Montag - Freitag', time: '08:00 - 20:00 Uhr' },
      { day: 'Samstag', time: '09:00 - 18:00 Uhr' },
      { day: 'Sonntag', time: '10:00 - 16:00 Uhr' },
      { day: 'Notfälle', time: '24/7 verfügbar' }
    ],
    coordinates: '52.5027,13.3315'
  };

  const quickActions = [
    {
      icon: 'Navigation',
      title: 'Route planen',
      description: 'Wegbeschreibung zu unserem Büro',
      action: 'Google Maps öffnen'
    },
    {
      icon: 'Phone',
      title: 'Direkt anrufen',
      description: 'Sofortige telefonische Beratung',
      action: 'Jetzt anrufen'
    },
    {
      icon: 'Mail',
      title: 'E-Mail senden',
      description: 'Schriftliche Anfrage stellen',
      action: 'E-Mail schreiben'
    },
    {
      icon: 'Calendar',
      title: 'Termin buchen',
      description: 'Persönlichen Beratungstermin vereinbaren',
      action: 'Termin vereinbaren'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Unser Standort in Berlin
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Besuchen Sie uns in unserem modernen Büro am Kurfürstendamm in Berlin 
            oder kontaktieren Sie uns für eine telefonische Beratung.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Office Information */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-elevated p-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Building" size={24} color="white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-text-primary">
                    {officeInfo?.name}
                  </h3>
                  <p className="text-text-secondary text-sm">
                    {officeInfo?.parent}
                  </p>
                </div>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <Icon name="MapPin" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-text-primary mb-1">Adresse</h4>
                    <p className="text-text-secondary">
                      {officeInfo?.address?.street}<br />
                      {officeInfo?.address?.city}<br />
                      {officeInfo?.address?.country}
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Icon name="Phone" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-text-primary mb-1">Telefon</h4>
                    <a 
                      href="tel:09001000312"
                      className="text-text-secondary font-mono hover:text-primary transition-colors"
                    >
                      {officeInfo?.contact?.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Icon name="Mail" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-text-primary mb-1">E-Mail</h4>
                    <p className="text-text-secondary">
                      {officeInfo?.contact?.email}
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Icon name="Clock" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-text-primary mb-2">Öffnungszeiten</h4>
                    <div className="space-y-1">
                      {officeInfo?.hours?.map((schedule, index) => (
                        <div key={index} className="flex justify-between text-sm">
                          <span className="text-text-secondary">{schedule?.day}:</span>
                          <span className="text-text-primary font-medium">{schedule?.time}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="grid sm:grid-cols-2 gap-4">
              {quickActions?.map((action, index) => (
                <div key={index} className="bg-white rounded-lg shadow-professional p-4 hover:shadow-elevated transition-shadow duration-200">
                  <div className="flex items-center space-x-3 mb-2">
                    <Icon name={action?.icon} size={20} color="var(--color-primary)" />
                    <h4 className="font-semibold text-text-primary">{action?.title}</h4>
                  </div>
                  <p className="text-sm text-text-secondary mb-3">{action?.description}</p>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName={action?.icon}
                    iconPosition="left"
                    className="w-full"
                    onClick={() => {
                      if (action?.icon === 'Phone') {
                        window.location.href = 'tel:09001000312';
                      } else if (action?.icon === 'Mail') {
                        window.location.href = 'mailto:info@advocall.de';
                      } else if (action?.icon === 'Navigation') {
                        window.open(`https://www.google.com/maps/search/?api=1&query=Kurfürstendamm+14,+10719+Berlin`, '_blank');
                      }
                    }}
                  >
                    {action?.action}
                  </Button>
                </div>
              ))}
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-2xl shadow-elevated overflow-hidden">
            <div className="h-96 lg:h-[500px] relative">
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title="AdvoCall Professional - Berlin Office"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${officeInfo?.coordinates}&z=16&output=embed`}
                className="border-0"
              />
              
              <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm rounded-lg p-3 shadow-lg">
                <div className="flex items-center space-x-2">
                  <Icon name="MapPin" size={16} color="var(--color-primary)" />
                  <span className="text-sm font-medium text-text-primary">
                    Berlin
                  </span>
                </div>
              </div>
            </div>

            <div className="p-6">
              <h3 className="text-lg font-bold text-text-primary mb-2">
                Zentral gelegen am Kurfürstendamm
              </h3>
              <p className="text-text-secondary text-sm mb-4">
                Unser Büro befindet sich am Kurfürstendamm 14, nur wenige Minuten 
                vom Bahnhof Zoologischer Garten und der City West entfernt. Öffentliche Verkehrsmittel 
                und Parkmöglichkeiten sind in unmittelbarer Nähe verfügbar.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  variant="default"
                  iconName="Navigation"
                  iconPosition="left"
                  className="bg-primary hover:bg-primary/90 text-white flex-1"
                  onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=Kurfürstendamm+14,+10719+Berlin`, '_blank')}
                >
                  Route planen
                </Button>
                
                <Button
                  variant="outline"
                  iconName="Phone"
                  iconPosition="left"
                  className="flex-1"
                  onClick={() => window.location.href = 'tel:09001000312'}
                >
                  Anrufen
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-16 bg-white rounded-2xl shadow-elevated p-8">
          <div className="text-center mb-8">
            <Icon name="Info" size={32} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-text-primary mb-2">
              Wichtige Hinweise für Ihren Besuch
            </h3>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <Icon name="Car" size={24} color="var(--color-primary)" className="mx-auto mb-3" />
              <h4 className="font-semibold text-text-primary mb-2">Parkmöglichkeiten</h4>
              <p className="text-sm text-text-secondary">
                Tiefgarage im Gebäude verfügbar. Alternativ öffentliche Parkplätze 
                in der Umgebung (kostenpflichtig).
              </p>
            </div>

            <div className="text-center">
              <Icon name="Train" size={24} color="var(--color-primary)" className="mx-auto mb-3" />
              <h4 className="font-semibold text-text-primary mb-2">Öffentliche Verkehrsmittel</h4>
              <p className="text-sm text-text-secondary">
                U-Bahn Uhlandstraße (2 Min zu Fuß), S-Bahn Zoologischer Garten (5 Min zu Fuß), 
                Bus-Haltestellen direkt am Kurfürstendamm.
              </p>
            </div>

            <div className="text-center">
              <Icon name="Clock" size={24} color="var(--color-primary)" className="mx-auto mb-3" />
              <h4 className="font-semibold text-text-primary mb-2">Terminvereinbarung</h4>
              <p className="text-sm text-text-secondary">
                Persönliche Termine nach Vereinbarung. Telefonische Beratung 
                auch ohne Termin möglich.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficeLocation;